import React from "react";
import clsx from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  allowDecimal?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: boolean;
  imageName?: string;
  startIcon?: any;
  forceDecimal?: boolean;
  negativeOnly?: boolean;
  negativeLabel?: boolean;
  iconOnClick?: () => void;
}

const onForceDecimal = (e: any) => {
  return (e.target.value = e.target.valueAsNumber.toFixed(2));
};

// FIXME: remove w-full
const BASE_STYLES =
  "border border-[#F8F9FA] font-[Gilroy-Medium] rounded text-[#233F6F] outline-none bg-[#F8F9FA] text-[16px] font-normal py-[10px] px-4 w-full h-[40px]";

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      disabled,
      helperText,
      className,
      allowDecimal,
      dataTestId,
      icon,
      imageName,
      startIcon,
      forceDecimal,
      negativeOnly,
      negativeLabel,
      iconOnClick,
      ...props
    }: InputProps,
    ref
  ) => {
    const allowStep = allowDecimal && props.type === "number";

    return (
      <div className="space-y-1 w-full">
        {label ? (
          <label
            className="text-[#8A96AB] font-[Gilroy-Medium] block text-sm tracking-[1px]  font-normal leading-[16.98px]"
            data-testid="input-label"
            htmlFor={id}
          >
            {label}
          </label>
        ) : null}
        <div className="relative">
          {startIcon ? (
            <p className="h-full px-2 absolute left-2 top-[9px] text-heading-color font-[Gilroy-Medium]">
              {startIcon}
            </p>
          ) : null}
          {negativeLabel ? (
            <p className="h-full px-2 absolute left-6 top-[9px] text-heading-color font-[Gilroy-Medium]">
              -
            </p>
          ) : null}
          <input
            {...props}
            data-testid={dataTestId}
            aria-invalid={!!error}
            disabled={disabled}
            aria-disabled={disabled}
            id={id}
            step={allowStep ? "0.01" : undefined}
            ref={ref}
            onBlur={forceDecimal ? onForceDecimal : null}
            onInput={
              negativeOnly
                ? (e: any) => (e.target.value = -Math.abs(e.target.value))
                : null
            }
            className={clsx(
              BASE_STYLES,

              className,
              error && "border-ilara-red",
              startIcon && "pl-8",
              startIcon && negativeLabel && "!pl-10"
            )}
          />
        </div>
        {icon ? (
          <img
            src={imageName}
            className="w-4 h-4 absolute top-0 !mt-8 mr-8 flex justify-center items-center right-0 cursor-pointer"
            alt=""
            onClick={iconOnClick}
          />
        ) : null}
        {error || helperText ? (
          <p
            className={`${
              error ? "text-red-500" : "text-ilara-secondary-text"
            } text-xs font-medium`}
            data-testid={error ? "input-error" : "input-helper-text"}
          >
            {error || helperText}
          </p>
        ) : null}
      </div>
    );
  }
);

export default CustomInput;
